<template>
  <el-dialog
    title="绑定人员"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
    :top="'2vh'"
  >
    <div class="product-add pb50">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户姓名">
          <el-input placeholder="请输入用户姓名" v-model="formInline.name" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input placeholder="请输入手机号" v-model="formInline.mobile" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="formInline.employee_identity" placeholder="请选择用户类型" clearable style="width: 150px;">
            <el-option label="正式员工" value="1"></el-option>
            <el-option label="临时员工" value="2"></el-option>
            <el-option label="外包员工" value="3"></el-option>
            <el-option label="实习员工" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员身份">
          <el-select v-model="formInline.member_identity" placeholder="请选择会员身份" clearable style="width: 150px;">
            <el-option label="普通会员" value="1"></el-option>
            <el-option label="VIP会员" value="2"></el-option>
            <el-option label="SVIP会员" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输类型">
          <el-select v-model="formInline.transport_type" placeholder="请选择运输类型" clearable style="width: 150px;">
            <el-option label="客运" value="1"></el-option>
            <el-option label="货运" value="2"></el-option>
            <el-option label="危运" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌">
          <el-select v-model="formInline.political_status" placeholder="请选择政治面貌" clearable style="width: 150px;">
            <el-option label="中共党员" value="1"></el-option>
            <el-option label="共青团员" value="2"></el-option>
            <el-option label="群众" value="3"></el-option>
            <el-option label="民主党派" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="人员姓名" width="100"></el-table-column>
            <el-table-column prop="employee_identity" label="用户类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.employee_identity === '1'">正式员工</span>
                <span v-else-if="scope.row.employee_identity === '2'">临时员工</span>
                <span v-else-if="scope.row.employee_identity === '3'">外包员工</span>
                <span v-else-if="scope.row.employee_identity === '4'">实习员工</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="member_status" label="会员状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.member_status === '1'" type="success">正常</el-tag>
                <el-tag v-else-if="scope.row.member_status === '0'" type="info">过期</el-tag>
                <el-tag v-else type="info">-</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="member_validity" label="会员有效期" width="120"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
            <el-table-column prop="age" label="年龄" width="80"></el-table-column>
            <el-table-column prop="id_card" label="身份证信息" width="180"></el-table-column>
            <el-table-column prop="political_status" label="政治面貌" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.political_status === '1'">中共党员</span>
                <span v-else-if="scope.row.political_status === '2'">共青团员</span>
                <span v-else-if="scope.row.political_status === '3'">群众</span>
                <span v-else-if="scope.row.political_status === '4'">民主党派</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="license_number" label="车牌号" width="120"></el-table-column>
            <el-table-column prop="gender" label="性别" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.gender === '1'">男</span>
                <span v-else-if="scope.row.gender === '2'">女</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="license_type" label="准驾车型" width="120"></el-table-column>
            <el-table-column prop="transport_type" label="运输类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.transport_type === '1'">客运</span>
                <span v-else-if="scope.row.transport_type === '2'">货运</span>
                <span v-else-if="scope.row.transport_type === '3'">危运</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="license_color" label="车牌颜色" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.license_color === '1'">蓝色</span>
                <span v-else-if="scope.row.license_color === '2'">黄色</span>
                <span v-else-if="scope.row.license_color === '3'">绿色</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="submitLoading">确定绑定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Ma_ygApi from '@/api/ma_yg.js';
import Ma_trainingApi from '@/api/ma_training.js';

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      loading: true,
      submitLoading: false,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      selectedRows: [],
      formInline: {
        name: '',
        mobile: '',
        employee_identity: '',
        member_identity: '',
        transport_type: '',
        political_status: ''
      }
    };
  },
  created() {
    this.dialogVisible = this.open_bind;
    this.getData();
  },
  props: ["open_bind", "ma_training_id"],
  methods: {
    dialogFormVisible() {
      this.$emit("close", { openDialog: false });
    },
    cancelFunc() {
      this.dialogFormVisible();
    },
    getData() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Ma_ygApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    resetSearch() {
      this.formInline = {
        name: '',
        mobile: '',
        employee_identity: '',
        member_identity: '',
        transport_type: '',
        political_status: ''
      };
      this.curPage = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    onSubmit() {
      let self = this;
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要绑定的人员');
        return;
      }
      
      self.submitLoading = true;
      let userIds = self.selectedRows.map(item => item.ma_yg_id);
      
      Ma_trainingApi.bindUser({
        ma_training_id: self.ma_training_id,
        user_ids: userIds
      }, true)
        .then(data => {
          self.submitLoading = false;
          self.$message.success('绑定成功');
          self.$emit("bind", { selectedRows: self.selectedRows });
          self.dialogFormVisible();
        })
        .catch(error => {
          self.submitLoading = false;
        });
    }
  }
};
</script>

<style>
.el-dialog__body {
  max-height: none !important;
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_training/indexx/part/bind.vue